import { cloneDeep } from 'lodash';

// Function to transaform the advance filter output to an array of strings
export function advanceFiltersNormalizer(
  advanceFilters?: Record<string, any>[],
  initialValue?: Record<string, any>
): Record<string, any> {
  const normalizedFilters: Record<string, any> = cloneDeep(initialValue) ?? {};

  if (!advanceFilters) {
    return normalizedFilters;
  }

  advanceFilters
    .filter(({ value }) => value !== undefined)
    .forEach(({ id, value }) => {
      if (Array.isArray(value)) {
        normalizedFilters[id] = value.join(',');
      } else if (typeof value === 'object') {
        Object.entries(value)
          .filter(([, filterValue]) => filterValue)
          .forEach(([filterName, filterValue]: [string, any]) => {
            normalizedFilters[filterName] = filterValue.toString();
          });
      } else {
        normalizedFilters[id] = value.toString();
      }
    });

  return normalizedFilters;
}

export function hasActiveAdvanceFilters(advanceFilters?: Record<string, any>[], textFilter?: string): boolean {
  const initialValue = textFilter ? { name: textFilter } : undefined;
  const normalizedFilters = advanceFiltersNormalizer(advanceFilters, initialValue);
  return Boolean(Object.keys(normalizedFilters).length);
}
